import { getSecureLocalItem } from "utils/secureSessionStorage";
import api from "./api";

const getAuthConfig = async (customHeaders = {}) => {
  const token = getSecureLocalItem("token");
  return {
    headers: {
      Authorization: `${token}`,
      ...customHeaders,
    },
  };
};

// Banner APIs
export const createBanner = async (formData) => {
  try {
    const config = await getAuthConfig({
      "Content-Type": "multipart/form-data",
    });
    const response = await api.post("/createBanner", formData, config);
    return response;
  } catch (error) {
    throw error;
  }
};


//Create Web Banner APIs
export const createWebBanner = async (formData) => {
  try {
    const config = await getAuthConfig({
      "Content-Type": "multipart/form-data",
    });
    const response = await api.post("/createWebAppBanner", formData, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAllBanners = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllBanners", config);
    return response;
  } catch (error) {
    throw error;
  }
};

//Get All Web Banner APi
export const getAllWebBanners = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllWebAppBanners", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateBanner = async (id, data) => {
  try {
    const config = await getAuthConfig();
    const response = await api.put(`/updateBanner/${id}`, data, config);
    return response;
  } catch (error) {
    throw error;
  }
};

//Update Wen Banner
export const updateWebBanner = async (id, data) => {
  try {
    const config = await getAuthConfig();
    const response = await api.put(`/updateWebAppBanner/${id}`, data, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteBanner = async (id) => {
  try {
    const config = await getAuthConfig();
    const response = await api.delete(`/deleteBanner/${id}`, config);
    return response;
  } catch (error) {
    throw error;
  }
};

// Delete Web Banner
export const deleteWebBanner = async (id) => {
  try {
    const config = await getAuthConfig();
    const response = await api.delete(`/deleteWebAppBanner/${id}`, config);
    return response;
  } catch (error) {
    throw error;
  }
};

// Title APIs
export const getTitle = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getTitle", config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateTitle = async (data) => {
  try {
    const config = await getAuthConfig();
    const response = await api.post("/updateTitle", data, config);
    return response;
  } catch (error) {
    throw error;
  }
};

export const contactDetails = async () => {
  try {
    const config = await getAuthConfig();
    const response = await api.get("/getAllContactForms", config);
    return response;
  } catch (error) {
    throw error;
  }
};
